export const dadosIniciais = {
  idPaciente: 0,
  idVinculo: 0,
  anamnese: "",
  sintomasEQueixas: "",
  examesPredefinidos: "",
  examesPredefinidosSelect: [],
  examesPredefinidosExamesEProcedimentos: [],
  outrosExamesLaboratoriais: [],
  examesLaboratoriaisObservacao: "",

  // outros exames
  descricaoSolicitacaoExame: "",
  modeloExame: "",
  tipoExame: "",
  solicitacaoOutrosExames: [],

  //-----------------------

  condutaConclusaoEncaminhamentos: "",

  frequenciaCardiaca: "",
  pressaoArterial: "",
  pesoAtual: "000000",
  perdaDePeso: "",
  fluenciaVerbal: "",
  rastreioComportamental: "",
  apatia: "",
  statusCognitivo: "",
  capacidadeVitalForcada: "",
  pressaoInspiratoria: "",
  pressaoExpiratoria: "",
  pressaoNasalInspiratoria: "",
};

export const examesPredefinidosOptions = [
  { key: "Adicionar todos os exames", value: "2" },
  { key: "Exames complementares (PDCT)", value: "3" },
];

export const examesPredefinidosList = [
  { key: "Hemograma completo", value: "1" },
  { key: "VSH", value: "2" },
  { key: "PCR", value: "3" },
  { key: "TGO", value: "4" },
  { key: "TGP", value: "5" },
  { key: "GGT", value: "6" },
  { key: "HTLV 1 e 2", value: "7" },
  { key: "FAN", value: "8" },
  { key: "Fator reumatóide", value: "9" },
  { key: "ECA", value: "10" },
  { key: "Lactase", value: "11" },
  { key: "Anticorpo anti-GM1", value: "12" },
  { key: "Billirubinas total direta e indireta", value: "13" },
  { key: "LDH", value: "14" },
  { key: "Vitamina B12", value: "15" },
  { key: "Ácido fólico", value: "16" },
  { key: "Glicemia", value: "17" },
  { key: "CPK", value: "18" },
  { key: "Anticorpo anti-Hu", value: "19" },
  { key: "Anticorpo anti-MAG", value: "20" },
  { key: "Anticorpo anti-DNA", value: "21" },
  { key: "Anticorpo anti-AChR", value: "22" },
  { key: "Anticorpo anti-MUSK", value: "23" },
  { key: "Sorologia para borrelia", value: "24" },
  { key: "Uréia", value: "25" },
  { key: "Creatina", value: "26" },
  { key: "Sódio", value: "27" },
  { key: "Fósforo", value: "28" },
  { key: "TSH", value: "29" },
  { key: "T4 Livre", value: "30" },
  { key: "Ácido úrico", value: "31" },
  { key: "Albumina", value: "32" },
  { key: "Colesterol HDL", value: "33" },
  { key: "Colesterol LDL", value: "34" },
  { key: "Colesterol Total", value: "35" },
  { key: "Imunoeletroforese", value: "36" },
  { key: "Anti-HIV", value: "37" },
  { key: "Anti-HCV", value: "38" },
  { key: "HbsAg", value: "39" },
  { key: "VDRL", value: "40" },
  { key: "Ferritina", value: "41" },
  { key: "Fosfatase Alcalina", value: "42" },
  { key: "Glicose", value: "43" },
  { key: "Triglicerídeos", value: "44" },
  { key: "Creatina Quinase", value: "45" },
  { key: "Creatinina", value: "46" },
];
